import { z } from "zod";

const EmployeeLoginSchema = z.object({
    name: z.string().nonempty("Name is required."),
    email: z
        .string()
        .nonempty("Email is required.")
        .email("Please provide a valid email address."),
    password: z
        .string()
        .nonempty("Password is required.")
        .min(8, "Password must be at least 8 characters long."),
    phone: z
        .string()
        .nonempty("Phone number is required.")
        .regex(/^\d{10,15}$/, "Please provide a valid phone number."),
    permissions: z
        .array(z.string())
        .nonempty("At least one permission must be selected."),
});

export default EmployeeLoginSchema;